import React, { createContext, useContext, useState, useCallback } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [legalKey, setLegalKey] = useState(null); // 'privacy' | 'terms' | 'cookies'
  const [cookieSettingsOpen, setCookieSettingsOpen] = useState(false);

  const openLegal = useCallback((key) => setLegalKey(key), []);
  const closeLegal = useCallback(() => setLegalKey(null), []);
  const openCookieSettings = useCallback(() => setCookieSettingsOpen(true), []);
  const closeCookieSettings = useCallback(() => setCookieSettingsOpen(false), []);

  return (
    <UIContext.Provider
      value={{
        legalKey,
        openLegal,
        closeLegal,
        cookieSettingsOpen,
        openCookieSettings,
        closeCookieSettings,
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used within UIProvider");
  return ctx;
}
